import { render, staticRenderFns } from "./enquiryUser.vue?vue&type=template&id=24a58a90&"
import script from "./enquiryUser.vue?vue&type=script&lang=js&"
export * from "./enquiryUser.vue?vue&type=script&lang=js&"
import style0 from "./enquiryUser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports